import { render, staticRenderFns } from "./image_lists.vue?vue&type=template&id=795d21d8&scoped=true"
import script from "./image_lists.vue?vue&type=script&lang=js"
export * from "./image_lists.vue?vue&type=script&lang=js"
import style0 from "./image_lists.vue?vue&type=style&index=0&id=795d21d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d21d8",
  null
  
)

export default component.exports